/**
 * Loads membersDatabase + license fields for a user (Employee List "more details" / edit).
 * Not used for the main roster — only on demand.
 */

/**
 * @param {FirebaseFirestore.Firestore} db
 * @param {string} userId
 * @returns {Promise<{ employeeId: string, timeZone: string, guid: string, deskId: string, loginAllowed: boolean, createdAt: firebase.firestore.Timestamp | null } | null>}
 */
export async function fetchEmployeeExtendedDetails(db, userId) {
  if (!db || !userId) return null;

  const memberDoc = await db.collection('membersDatabase').doc(userId).get();
  if (!memberDoc.exists) return null;

  const memberData = memberDoc.data() || {};
  const encryptedLicenseKey = memberData.encryptedLicenseKey;
  let guid = null;
  let deskId = null;

  if (encryptedLicenseKey) {
    const licenseQuery = await db
      .collection('licenseDatabase')
      .where('value', '==', encryptedLicenseKey)
      .limit(1)
      .get();
    if (!licenseQuery.empty) {
      const licenseDoc = licenseQuery.docs[0];
      guid = licenseDoc.id;
      deskId = licenseDoc.data().deskId || null;
    }
  }

  return {
    employeeId: memberData.employeeId || 'N/A',
    timeZone: memberData.timeZone || 'N/A',
    guid: guid || 'N/A',
    deskId: deskId || 'N/A',
    loginAllowed: memberData.loginAllowed === true,
    activeTeamId: memberData.activeTeamId || null,
    createdAt: memberData.createdAt || null,
  };
}
